import React from "react";
import s from "./FormCheckBox.module.scss";

const FormCheckBox = ({ name, label, register }) => {
  return (
    <div>
			<label className={s.container}>{label}
				<input ref={!!register ? register : null} name={name} type="checkbox" />
				<span className={s.checkmark}></span>
			</label>
      
    </div>
  );
};

export default FormCheckBox;
